

<div mat-dialog-title>
  {{'modalChoixStructure.search.titre' | translate }}<br>
  <small>{{'moduleLaboratoire.infoStructureFrancaise' | translate}}</small>
</div>


<div mat-dialog-content>
  <div [hidden]="displayNewLab">

    <div class="search-box mat-elevation-z3">
      <mat-icon class="search-box-prefix">search</mat-icon>

      <input [(ngModel)]="search"
        (ngModelChange)="onChangeResearch($event)"
        name="search"
        type="search"
        class="search-box-search"
        placeholder="{{'modalChoixStructure.search.placeholder' | translate}}">

        @if (search?.length > 0) {
          <div>
            <button mat-icon-button (click)="search = ''; onChangeResearch(null);">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        }
      </div>



      <div class="container-mat-table container-mat-table-sticky">
        <table class="no-zebra mat-table-data-list mat-table-dense mat-table-head-ultradense" mat-table matSort [dataSource]="laboratoires" (matSortChange)="changeSort($event)">

          <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'general.structures' | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <strong>{{element.label}}</strong><br>
              {{(element.adresse.numEtVoie !== '-' ? (element.adresse.numEtVoie + ' - ') : '')}}{{element.adresse.codePostal}} - {{element.adresse.ville}}
            </td>
          </ng-container>

          <ng-container matColumnDef="sigle">
            <th mat-header-cell *matHeaderCellDef>{{ 'general.sigle' | translate }}</th>
            <td mat-cell *matCellDef="let element" width="70px">
              {{element.sigle}}
            </td>
          </ng-container>

          <ng-container matColumnDef="directeur.nom">
            <th mat-header-cell  *matHeaderCellDef mat-sort-header>{{'general.directeurGeneral' | translate}}</th>
            <td mat-cell *matCellDef="let element" width="200px">
              {{ ('general.civilite_values.' + (element.directeur.civilite | uppercase )) | translate}}
              {{element.directeur.nom}}  {{element.directeur.prenom}}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell  *matHeaderCellDef mat-sort-header>&nbsp;</th>
            <td mat-cell *matCellDef="let element" width="70px">
              <button (click)="submitWithSelection(element)" mat-stroked-button>
                {{ 'general.selectionner' | translate }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="MATERIAL_COLUMNS; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: MATERIAL_COLUMNS;"></tr>

        </table>
        <mat-paginator  class="mat-paginator-sticky" [pageSize]="10" [length]="total"
          [pageSizeOptions]="pageSizeOptions"  (page)="onPaginatorPageChange()"
        showFirstLastButtons></mat-paginator>
      </div>

      <p class="alert alert-light mt-1 mb-0 rappelStructure">
        <mat-icon>info</mat-icon>
        {{ 'modalChoixStructure.rappelSignalementStructure' | translate }}
      </p>
    </div>
  </div>

  <div mat-dialog-actions>
    <button [mat-dialog-close]="null" mat-button mat-flat-button color="primary" >{{ 'general.annuler' | translate }}</button>
  </div>
